"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonErrorMessage = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconDisplay = require("../icons/IconDisplay");

var _fieldUtils = require("../microFields/fieldUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var ButtonErrorMessage = function ButtonErrorMessage(_ref) {
  var errorMessage = _ref.errorMessage,
      skipToErrorLinkMessage = _ref.skipToErrorLinkMessage,
      firstErrorField = _ref.firstErrorField,
      isPolite = _ref.isPolite,
      iconType = _ref.iconType;
  var containerProps = {
    className: 'button-error',
    'aria-live': isPolite ? 'polite' : 'assertive',
    'aria-atomic': true
  };
  var autoFocus = (0, _react.useCallback)(function (el) {
    return el ? el.focus() : null;
  }, []);
  /* leave the container in the DOM
   * so it will announce it's contents when they are added
   */

  return _react.default.createElement("span", containerProps, iconType && errorMessage && _react.default.createElement(_IconDisplay.Icon, {
    type: iconType
  }), errorMessage, ' ', errorMessage && skipToErrorLinkMessage && firstErrorField && _react.default.createElement("a", {
    styling: "link",
    href: "#".concat((0, _fieldUtils.getAllFieldElementIds)(firstErrorField).input.id),
    className: "skipToErrorLinkMessage",
    id: "skipToErrorLink",
    ref: autoFocus
  }, skipToErrorLinkMessage));
};

exports.ButtonErrorMessage = ButtonErrorMessage;
ButtonErrorMessage.defaultProps = {
  errorMessage: null,

  /* null for falsy object */
  isPolite: false,
  iconType: null,
  skipToErrorLinkMessage: '',
  firstErrorField: null
};
ButtonErrorMessage.propTypes = {
  errorMessage: _propTypes.default.string,
  isPolite: _propTypes.default.bool,
  iconType: _propTypes.default.string,
  skipToErrorLinkMessage: _propTypes.default.string,
  firstErrorField: _propTypes.default.string
};